import { CircularProgress, Container, Stack, Typography } from '@mui/material';
import { Button } from '@ghs/components';
import { useUnit } from 'effector-react';
import useMountedEvent from '../../../hooks/useMountedEvent';
import { hasGhsAdminUtilsRefreshKbPermissions } from '../../../services/PermissionService/PermissionService';
import { $$utils } from './model';
import { $$app } from '../../../components/App/model';

export default function GhsAdminUtilsPage() {
  useMountedEvent($$utils.pageMounted);

  const userDetails = useUnit($$app.$userDetails);
  const isRefreshKnowledgeBaseMtPending = useUnit($$utils.$isRefreshKnowledgeBaseMtPending);
  const isRefreshKnowledgeBaseStResellersPending = useUnit($$utils.$isRefreshKnowledgeBaseStResellersPending);

  return (
    <Container id="internal-utilities-container">
        <Typography variant="h4" color="text.primary" sx={{ mt: 2, mb: 6 }}>
          Utilities
        </Typography>

        {hasGhsAdminUtilsRefreshKbPermissions(userDetails?.permissions) && (
          <Stack spacing={1}>
            <Button color="primary" onClick={() => $$utils.refreshKnowledgeBaseMtButtonClicked()} size="medium" variant="contained" disabled={isRefreshKnowledgeBaseMtPending}>
              Refresh Knowledge Base - MT
              {isRefreshKnowledgeBaseMtPending && <CircularProgress size={16} color="inherit" sx={{ ml: 1 }} />}
            </Button>

            <Button color="primary" onClick={() => $$utils.refreshKnowledgeBaseStResellersButtonClicked()} size="medium" variant="contained" disabled={isRefreshKnowledgeBaseStResellersPending}>
              Refresh Knowledge Base - ST Resellers
              {isRefreshKnowledgeBaseStResellersPending && <CircularProgress size={24} color="inherit" sx={{ ml: 1 }} />}
            </Button>
          </Stack>
        )}
    </Container>
  );
}
